// Read more: https://kit.svelte.dev/docs/load
import { base } from '$app/paths';
import debug from 'debug';
import { getBlockImportPromises } from '$lib/helper';
import { getUserId } from '$lib/global/storage';
import { nanoid } from 'nanoid/non-secure';

// Types
import type { PageLoad } from './$types';

const debugLog = debug('routes:+page.js');

export const load: PageLoad = async ({ fetch }) => {
    if (!window.sessionId) {
        window.sessionId = nanoid();
    }
    const userId = getUserId() || 'error';
    const sessionId = window.sessionId || 'error';
    const res = await fetch(
        `${base}/data/indexPage.json?v=${window.campaignVersionId}&uid=${userId}&sid=${sessionId}`,
    );
    const pageData = await res.json();

    debugLog(pageData);

    // Preload all page blocks
    const blockImportPromises = getBlockImportPromises(pageData?.components);
    await Promise.all(blockImportPromises);

    return pageData;
};
